module.exports = __webpack_public_path__ + "img/adjust-height.17bdcb08.svg";